<template>
  <div class="p-1">
    <div-table
      :config="configList"
      :data="payements"
      :idWharhouse="idWharhouse"
      :currentUser="currentUser"
      :element="element"
      @reset="reset"
      @refresh="refresh"
      @showProducts="showOrders"
      @filtrer="filtrer"
      @search="search"
      :statusShipp="statusPayment"
      :loading="loading"
      :paginate="paginate"
      :statusShippChange="statusShippChange"
      @paginatation="paginatation"
      @selectAllCheckbox="selectAllCheckbox" @getRowDetail="getRowDetail" :tabId="tabId"
       @emtyTabId="emtyTabId"
    ></div-table>
  </div>
</template>

<script>
import config from "./config";
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      configList: config.list,
      loading: false,
      payements: [],
      element: {},
      sellers: [],
      filters:{},
      tabId:[],
      show_modal: false,
      limit: 100,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      statusPayment: ['pending', 'processed'],
      methods: ["transfer", "paypal", "cash"],
      statusShippChange:["processed"],
    };
  },
  computed: {
        warhouseSelected(){
            return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
        },
    }, 
  watch: { 
        'warhouseSelected': async function(oldVal, newVal) {
            // await this.getwharhouseId();
            // await this.getSellers();
            // this.setDataSelect("seller", this.sellers, null);
            // await this.reset();
        },
        'idWharhouse': async function(oldVal, newVal) {
            this.idWharhouse=oldVal;  
            await this.getSellers();
            this.setDataSelect("seller", this.sellers, null);
            await this.reset();
        }
   },
  async mounted() {
    if(this.currentUser.type != "Admin") {this.limit=10;this.filters.limit=10}
    await this.getPayement({ limit: this.limit });
    await this.getSellers();
    this.setDataSelect("seller", this.sellers, null);
    this.setDataSelect("method", this.methods, null);
     this.setDataSelect("status", this.statusPayment, null);
     if (this.currentUser.type == "Seller") {
          let pos = this.configList.columns.map(function (e) {
                      return e.name;
                      }).indexOf('Seller');
          if(pos!=-1)  this.configList.columns.splice(pos, 1);           
     }
  },
  methods: {
    async getwharhouseId(){
           await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    },
     emtyTabId(){
      console.log('goooood check')
      let columns = document.querySelectorAll('.rowCheckbox');
      columns.forEach(column => {column.checked = false});
      let clomnselectA = document.querySelector('.checkallbbox');
      clomnselectA.checked = false

      this.tabId = [];
    },
    selectAllCheckbox($event) {
        let columns = document.querySelectorAll('.rowCheckbox');
        this.tabId = [];
        if ($event.target.checked == true) {
            columns.forEach(column => {
                column.checked = true;        
                this.tabId.push({id:column.id,status:column.getAttribute('status'),count:parseInt(column.getAttribute('count')),amount:parseFloat(column.getAttribute('amount'))});
               
            });
        } else {
            columns.forEach(column => {column.checked = false});
            this.tabId = [];
        }
       // console.log('tab all------------',this.tabId)
    },
    getRowDetail(item, id) {
        // let rows = this.selectedRows;
        let itemInRow = this.tabId.filter(item => item.id === id);
        let isItemInRow = itemInRow.length > 0;
            
        if (isItemInRow) { 
            let pos = this.tabId.map(function (e) {return e.id;}).indexOf(id);
            this.tabId.splice(pos, 1);
        }else this.tabId.push({id:id,status:item.status,count:item.count,amount:item.amount});

        if(this.tabId.length === 0){
              let columns = document.querySelectorAll('.checkallbbox');
              columns.forEach(column => {column.checked = false});
        }
        console.log('this.tabId------------',this.tabId)
    },
     setDataSelect(model, data, splice) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if (
          this.configList.filters.elements.champs[i].type === "select" &&
          this.configList.filters.elements.champs[i].key === model
        ) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            this.configList.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    async getSellers() {
      if (this.currentUser.type != "Seller") {
          const filter = {
            type: "Seller",
            limit:10
          };
            const res = await this.$server.search("users", filter);
            if (res.content.results) this.sellers = res.content.results;
            else this.sellers = [];
      }
    },
    async reset(data) {
      this.filters={};
      this.filters.limit= this.limit;
      await this.getPayement(this.filters);
    },
    async filtrer(data) {
      
       this.filters.limit=this.limit;
       this.filters.method=data.method;
       this.filters.date=data.date;
       this.filters.status=data.status;
       delete  this.filters.page;
       this.paginate.currentpage=1;

      if(data.seller) this.filters.seller=data.seller._id;
      await this.getPayement(this.filters);
    },
    /**********************************User and Status******************************************************/
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
      if(this.currentUser.type == "Seller") this.limit=10;
    },
    async refresh() {
      if(this.currentUser.type == "Seller") this.limit=10;
      await this.getPayement({ limit: this.limit });
       this.emtyTabId();
    },

    showOrders(index) {
      if (this.element !== this.payements[index]) {
        this.element = this.payements[index];
        //console.log("Je suis this.element", this.element);
      } else this.element = null;
    },
    async getPayement(filters) {
      this.loading = true;
      filters.warehouse=this.idWharhouse._id;

      const res = await this.$server.search("payments", filters);
      this.loading = false;
      if (res.content.results) {
        this.payements = res.content.results;
        this.payements.forEach(arg => {
          arg.amount=arg.amount.toFixed(2);
          if(arg.intervalDate && arg.intervalDate.toDate && arg.intervalDate.fromDate){
             arg.periode='[ '+this.$moment(arg.intervalDate.fromDate).format('yyyy-MM-DD')+' - '+this.$moment(arg.intervalDate.toDate).format('yyyy-MM-DD')+' ]';
          }   
        });
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.payements = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
      }
      // console.log('payments----------',this.payements)
    },
    async search(data) {
       this.paginate= {total: 0,currentpage: 1,lastpage: 1,per_page: 0,};
       const search = {
        name:data,
        warehouse:this.idWharhouse._id
       }
       this.loading = true;
     const  res = await this.$server.find("payments", search);
     this.loading = false;
       if (res.content.results) {
         this.payements = res.content.results; 
        this.payements.forEach(arg => {
          arg.amount=arg.amount.toFixed(2);
          if(arg.intervalDate && arg.intervalDate.toDate && arg.intervalDate.fromDate){
             arg.periode='[ '+this.$moment(arg.intervalDate.fromDate).format('yyyy-MM-DD')+' - '+this.$moment(arg.intervalDate.toDate).format('yyyy-MM-DD')+' ]';
          }   
        });
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.payements = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
      }
        
    },
    async remove(id) {
      this.$confirm("You want to delete this payment?").then(async (res) => {
        if (res) {
          const resp = await this.$server.delete("payments", { id: id });
          await this.refresh();
          alert("payment Deleted", "success");
        }
      });
    },
    /********************************************************************************************/
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
     
       this.filters.page=page;
      this.filters.limit=this.limit;
      this.getPayement(this.filters);
    },
  },
};
</script>

<style>
/* animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}
dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}
@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/**********************************Table Product PopUp ***************************/




</style>